// extracted by mini-css-extract-plugin
export default {"step2":"Step2_step2__14dq2","buttons":"Step2_buttons__4+67J","select":"Step2_select__7XiJh","nextButton":"Step2_nextButton__ukvaS","form":"Step2_form__58mBP"};